import { createI18n } from 'vue-i18n'
import fr from './fr.json'
import ar from './ar.json'
import darija from './darija.json'

export type Locale = 'fr' | 'ar' | 'darija'

const i18n = createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr,
    ar,
    darija,
  },
})

export default i18n

export function setLocale(locale: Locale) {
  i18n.global.locale.value = locale
}

export function getLocale(): Locale {
  return i18n.global.locale.value as Locale
}
